// extracted by mini-css-extract-plugin
module.exports = {"clusterIcon":"mapWithPads_clusterIcon__1KcvR"};